export default __webpack_public_path__ + "static/char-s-47-zh-Hant-42f68c00565417d93e438f16786e131b.webp";